"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSession = exports.subscribeSession = exports.getCurrentSession = exports.resolveHandshake = void 0;
const react_1 = require("react");
const registry_1 = require("~/plugins/registry");
const getGuestSession = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(APP_API_URL + "/guest/session", {
        headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) {
        return null;
    }
    const { id, token } = yield response.json();
    return { id, token };
});
const guestSource = {
    id: "guest",
    priority: 0,
    isAvailable: () => true,
    createHandshake: () => __awaiter(void 0, void 0, void 0, function* () {
        const session = yield getGuestSession();
        if (!session) {
            return null;
        }
        return { type: "guest", data: { accessToken: session.token } };
    }),
    getIdentity: () => ({ id: "", name: "Guest", picture: null }),
};
const pluginSources = () => registry_1.pluginRegistry.list().flatMap((plugin) => { var _a; return [...((_a = plugin.sessionSources) !== null && _a !== void 0 ? _a : [])]; });
const orderedSources = () => [...pluginSources(), guestSource].sort((a, b) => { var _a, _b; return ((_a = b.priority) !== null && _a !== void 0 ? _a : 0) - ((_b = a.priority) !== null && _b !== void 0 ? _b : 0); });
const resolveHandshake = () => __awaiter(void 0, void 0, void 0, function* () {
    for (const source of orderedSources()) {
        if (!source.isAvailable()) {
            continue;
        }
        const request = yield source.createHandshake();
        if (request) {
            return request;
        }
    }
    return null;
});
exports.resolveHandshake = resolveHandshake;
const sameIdentity = (a, b) => a === b ||
    (!!a && !!b && a.id === b.id && a.name === b.name && a.picture === b.picture);
const computeSession = () => {
    var _a;
    for (const source of orderedSources()) {
        if (!source.isAvailable()) {
            continue;
        }
        const identity = (_a = source.getIdentity) === null || _a === void 0 ? void 0 : _a.call(source);
        if (identity) {
            return identity;
        }
    }
    return null;
};
const sessionListeners = new Set();
let cachedSession = computeSession();
let sourceUnsubs = [];
const recomputeSession = () => {
    const next = computeSession();
    // Keep the reference stable when unchanged so getSnapshot is loop-safe.
    if (!sameIdentity(cachedSession, next)) {
        cachedSession = next;
        sessionListeners.forEach((fn) => fn());
    }
};
const resubscribeSources = () => {
    sourceUnsubs.forEach((unsub) => unsub());
    sourceUnsubs = orderedSources()
        .map((source) => { var _a; return (_a = source.subscribe) === null || _a === void 0 ? void 0 : _a.call(source, recomputeSession); })
        .filter((unsub) => !!unsub);
};
// A newly-registered plugin can add a source, so re-bind and recompute.
registry_1.pluginRegistry.onChange(() => {
    resubscribeSources();
    recomputeSession();
});
resubscribeSources();
const getCurrentSession = () => cachedSession;
exports.getCurrentSession = getCurrentSession;
const subscribeSession = (listener) => {
    sessionListeners.add(listener);
    return () => sessionListeners.delete(listener);
};
exports.subscribeSession = subscribeSession;
/** Reactive active display identity for menu UI. */
const useSession = () => (0, react_1.useSyncExternalStore)(exports.subscribeSession, exports.getCurrentSession, exports.getCurrentSession);
exports.useSession = useSession;
